import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children, requiredRole = null }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(null); // null = checking, true/false = result
    const location = useLocation();

    useEffect(() => {
        const checkAuth = () => {
            const token = localStorage.getItem('access_token') || localStorage.getItem('accessToken');
            const schoolId = localStorage.getItem('school_id');
            const userRole = localStorage.getItem('user_role');

            // Check if we have all required authentication data
            if (!token) {
                setIsAuthenticated(false);
                return;
            }

            // For parent panel, school context is important but not always required for legacy users
            // Check role if required
            if (requiredRole && userRole && userRole !== requiredRole) {
                setIsAuthenticated(false);
                return;
            }

            // TODO: Optionally verify token with backend
            // For now, assume valid if present
            setIsAuthenticated(true);
        };

        checkAuth();
    }, [requiredRole]);

    // Show loading while checking authentication
    if (isAuthenticated === null) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-orange-500"></div>
            </div>
        );
    }

    // Redirect to login if not authenticated
    if (!isAuthenticated) {
        console.log("Navigating to login page due to authentication failure.");
        return <Navigate to="/" state={{ from: location }} replace />;
    }

    // Render protected content
    return children;
};


export default ProtectedRoute;